import React from 'react';

import styles from '../Status.css';

/* eslint-disable react/prop-types */
const ListItem = ({children}) => (
  <ul className={styles.listItem}>
    <li>{children}</li>
  </ul>
);
/* eslint-enable react/prop-types */

/* eslint-disable react/jsx-key */
export const COLUMNS = [
  {
    header: 'version',
    key: 'version',
  },
  {
    header: 'added',
    key: 'added',
    class: styles.greyCell
  },
  {
    header: 'changes',
    key: 'changes',
    flexGrow: true
  }
];

export const DATA = [
  {
    added: '6/9/2018',
    version: '1.0.0',
    changes: <ListItem>Launch of the first version of the Airtel Design System. Added foundations pages and home page.</ListItem>
  },
  {
    added: '6/9/2018',
    version: '1.1.0',
    changes: <ListItem>Release of the following elements: Buttons, Links and Tabs.</ListItem>
  },
  {
    added: '24/9/2018',
    version: '1.1.1',
    changes: <ListItem>Release of the following elements: Action Icons, Dividers and Loadings.</ListItem>
  },
    {
    added: '1/10/2018',
    version: '1.1.2',
    changes: <ListItem>Release of the following elements: Badges, Paginations, Tags, Toggles and Tooltips.</ListItem>
  },
  {
    added: '4/10/2018',
    version: '1.2.2',
    changes: <ListItem>Release of the following components: Accordions, Footers, Maps and Notifications.</ListItem>
  },
  {
    added: '15/10/2018',
    version: '1.2.3',
    changes: [
      <ListItem>Release of the Inputs element.</ListItem>,
      <ListItem>Release of the following components: Header and Inputs.</ListItem>
    ]
  },
  {
    added: '19/10/2018',
    version: '1.2.4',
    changes: <ListItem>Release of the following components: Vertical Section Marker Component and Form.</ListItem>
  },
  {
    added: '03/12/2018',
    version: '1.2.4',
    changes: <ListItem>Release of the following components: Benefits, Cards, Hero, Hub, Skinny, Support and Others Banners.</ListItem>
  }
];



// WEBPACK FOOTER //
// ./src/containers/libraryStatus/constants/releaseNotesData.js